import { useToast } from '@/hooks/use-toast';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast';
import { CheckCircle2, AlertCircle, XCircle, Info, AlertTriangle } from 'lucide-react';

const getToastIcon = (variant?: string) => {
  const iconClass = "h-4 w-4 shrink-0 mt-0.5";

  switch (variant) {
    case 'success':
      return <CheckCircle2 className={`${iconClass} text-green-600`} />;
    case 'destructive':
      return <XCircle className={`${iconClass} text-red-600`} />;
    case 'warning':
      return <AlertTriangle className={`${iconClass} text-orange-600`} />;
    case 'info':
      return <Info className={`${iconClass} text-blue-600`} />;
    default:
      return <AlertCircle className={`${iconClass} text-gray-500`} />;
  }
};

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex gap-3 items-start min-w-0 flex-1">
              {getToastIcon(variant)}
              <div className="grid gap-0.5 min-w-0 flex-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && <ToastDescription>{description}</ToastDescription>}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
